import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CrewMemberProjectDto } from '../dtos/crew-member/crew-member-project.dto';
import { FeaturedCrewMember } from '../dtos/featured-crew-member.dto';
import { IndexDto } from '../dtos/index.dto';

@Injectable({
  providedIn: 'root',
})
export class IkonnectService {
  private apiUrl = environment.apiUrl + '/api/ikonnect';

  constructor(private http: HttpClient) { }

  initializeSettings(): Observable<any> {
    return this.http.get(`${this.apiUrl}`, { withCredentials: true });
  }

  getIndex(): Observable<IndexDto> {
    return this.http.get<IndexDto>(`${this.apiUrl}/${'index'}`, { withCredentials: true });
  }

  getFeaturedCrewMembers(): Observable<FeaturedCrewMember[]> {
    return this.http.get<FeaturedCrewMember[]>(`${this.apiUrl}/${'featuredCrewMembers'}`);
  }

  getProjectById(projectId: number): Observable<CrewMemberProjectDto> {
    return this.http.get<CrewMemberProjectDto>(`${this.apiUrl}/${'project'}/${projectId}`);
  }
}
